import { render, staticRenderFns } from "./RegularVideos.vue?vue&type=template&id=327445fd"
import script from "./RegularVideos.vue?vue&type=script&lang=js"
export * from "./RegularVideos.vue?vue&type=script&lang=js"
import style0 from "./RegularVideos.vue?vue&type=style&index=0&id=327445fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports